import React, { ReactElement, forwardRef } from "react";
import classnames from "classnames";
import { PanelProps } from "./panel.types";

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  (
    {
      className,
      mastheadImg,
      mastheadImgAltText,
      mastheadContent,
      panelHeader = null,
      children,
      ...rest
    },
    panelExternalRef
  ): ReactElement => {
    const cssClass = classnames("spark-panel", "spark-panel--card", className);

    if (panelHeader && mastheadImg) {
      console.error(
        "Failed prop type: The prop `panelHeader` is not allowed when using the `mastheadImg` prop."
      );
    }

    return (
      <div ref={panelExternalRef} className={cssClass} {...rest}>
        {mastheadImg && (
          <div className="spark-panel__masthead">
            <img src={mastheadImg} alt={mastheadImgAltText} />
            {mastheadContent}
          </div>
        )}
        {panelHeader && !mastheadImg && (
          <div className="spark-panel__header">{panelHeader}</div>
        )}
        <div className="spark-panel__content">{children}</div>
      </div>
    );
  }
);

Panel.displayName = "Panel";
